export default __webpack_public_path__ + "static/desktop-app-macos-4d77347980ac0bd5e04f223de6bba44a.png";